import { Component, OnInit } from '@angular/core';

declare var accordeons:any;

@Component({
  selector: 'app-spec-logo-praktisch',
  templateUrl: './spec-logo-praktisch.component.html',
  styleUrls: ['./spec-logo-praktisch.component.sass']
})
export class SpecLogoPraktischComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      accordeons.initAccordeons();
    }, 500);
  }

}
